module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/gutzol893226-bkg-335482cfd3f29447d08de8caefbc99a4.jpg";